import { http } from './http'
import { Pagination, PaginationParams } from './map'
import {
  Partner,
  PartnerCategory,
  PartnerCategoryPayload,
  PartnerPayload,
} from '../../common/models'

export const getPartnerCategories = (params?: PaginationParams) =>
  http.get<Pagination<PartnerCategory>>('/operations/partner-categories', {
    params,
  })

export const updatePartnerCategory = (
  id: string,
  data: PartnerCategoryPayload,
) => http.put<PartnerCategory>(`/operations/partner-categories/${id}`, data)

export const publishPartnerCategory = (ids: string[]) =>
  http.put<PartnerCategory[]>('/operations/partner-categories/publish', {
    ids,
  })

export const unpublishPartnerCategory = (ids: string[]) =>
  http.put<PartnerCategory[]>('/operations/partner-categories/unpublish', {
    ids,
  })

export const getPartnerCategory = (id: string) =>
  http.get<PartnerCategory>(`/operations/partner-categories/${id}`)

export const createPartnerCategory = (data: PartnerCategoryPayload) =>
  http.post<PartnerCategory>('/operations/partner-categories', data)

export const deletePartnerCategory = (ids: string[]) =>
  http.delete('/operations/partner-categories', {
    data: {
      ids,
    },
  })

export const getPartners = (params?: PaginationParams) =>
  http.get<Pagination<Partner>>('/operations/partners', {
    params,
  })

export const updatePartner = (id: string, data: PartnerPayload) =>
  http.put<Partner>(`/operations/partners/${id}`, data)

export const publishPartner = (ids: string[]) =>
  http.put<Partner[]>('/operations/partners/publish', {
    ids,
  })

export const unpublishPartner = (ids: string[]) =>
  http.put<Partner[]>('/operations/partners/unpublish', {
    ids,
  })

export const getPartner = (id: string) =>
  http.get<Partner>(`/operations/partners/${id}`)

export const createPartner = (data: PartnerPayload) =>
  http.post<Partner>('/operations/partners', data)

export const deletePartner = (ids: string[]) =>
  http.delete('/operations/partners', {
    data: {
      ids,
    },
  })

export const getPartnersByCategory = (id: string, params?: PaginationParams) =>
  http.get<Pagination<Partner>>(`/operations/partners/by-category/${id}`, {
    params,
  })
